export const homeModalSessionInfo = {
  homeModalSessionInfotitle: "Welcome back!",
  homeModalSessionInfotitleCurrentBalance: "Current balance",
  homeModalSessionInfoLastConnection: "Last access",
  homeModalSessionInfoLastConnectionAtTime: "at",
  homeModalSessionInfoLowBalanceWarning: "Your balance is running low. Would you like to deposit more money?",
  homeModalSessionInfoGoToDeposit: "Deposit",
  homeModalSessionInfoContinue: "Continue",
  homeModalSessionInfoDeposit: "Would you like to deposit more money?",
  homeModalSessionInfoAtTime: "at",
};
